/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TimelineSingleCompleted, TimelineSingleCurrent, TimelineSingleUpcoming, TimelineMultiple, TimelineMultipleData, TimelineMultipleCompletedData, TimelineMultipleCurrentData, TimelineMultipleUpcomingData, TimelineStates, TimelineIcons, TimelineSkeleton, TimelineAsChildrenSkeleton, TimelineItemSkeleton} from 'Docs/uilib/components/timeline/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    a: "a",
    p: "p",
    code: "code",
    h4: "h4"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsxs(_components.h3, {
      children: ["Timeline with multiple ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), ":"]
    }), "\n", _jsxs(_components.p, {
      children: ["We can pass down a list of ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), " as a variable to ", _jsx(_components.code, {
        children: "data"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["It's also possible to pass down ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), " as ", _jsx(_components.code, {
        children: "children"
      }), ", see ", _jsx(_components.a, {
        href: "/uilib/components/timeline/#timeline-with-multiple-timeline-items-passed-down-as-children",
        children: "example"
      }), "."]
    }), "\n", _jsx(TimelineMultipleData, {}), "\n", _jsxs(_components.h3, {
      children: ["Timeline with multiple ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), " passed down as children:"]
    }), "\n", _jsxs(_components.p, {
      children: ["Passing down ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), " as children"]
    }), "\n", _jsx(TimelineMultiple, {}), "\n", _jsxs(_components.h3, {
      children: ["Examples of Timelines with one ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline item"
      }), ":"]
    }), "\n", _jsxs(_components.h4, {
      children: ["Completed ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline item"
      }), ":"]
    }), "\n", _jsx(TimelineSingleCompleted, {}), "\n", _jsxs(_components.h4, {
      children: ["Current ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline item"
      }), ":"]
    }), "\n", _jsx(TimelineSingleCurrent, {}), "\n", _jsxs(_components.h4, {
      children: ["Upcoming ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline item"
      }), ":"]
    }), "\n", _jsx(TimelineSingleUpcoming, {}), "\n", _jsxs(_components.h3, {
      children: ["Setting property ", _jsx(_components.code, {
        children: "state"
      }), " of ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline item"
      }), ":"]
    }), "\n", _jsxs(_components.p, {
      children: ["Property ", _jsx(_components.code, {
        children: "state"
      }), " changes styling of icon, border, and font of the ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline item"
      })]
    }), "\n", _jsx(TimelineStates, {}), "\n", _jsxs(_components.h3, {
      children: ["Setting property ", _jsx(_components.code, {
        children: "icon"
      }), " of ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), ":"]
    }), "\n", _jsxs(_components.p, {
      children: ["Property ", _jsx(_components.code, {
        children: "icon"
      }), " is by default set based on the value of ", _jsx(_components.code, {
        children: "state"
      }), " property, but can be overwritten by passing a ", _jsx(_components.code, {
        children: "icon"
      }), ", see how to ", _jsx(_components.a, {
        href: "/uilib/components/icon#importing-icons",
        children: "import icons"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["See default icons based on value of ", _jsx(_components.code, {
        children: "state"
      }), " property in documentation for ", _jsx(_components.code, {
        children: "icon"
      }), " property of the ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline item"
      })]
    }), "\n", _jsx(TimelineIcons, {}), "\n", _jsx(_components.h3, {
      children: "Timeline skeleton:"
    }), "\n", _jsx(TimelineSkeleton, {}), "\n", _jsx(_components.h3, {
      children: "Timeline as children skeleton:"
    }), "\n", _jsx(TimelineAsChildrenSkeleton, {}), "\n", _jsxs(_components.h3, {
      children: [_jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "Timeline item"
      }), " skeleton:"]
    }), "\n", _jsx(TimelineItemSkeleton, {}), "\n", _jsxs(_components.h3, {
      children: ["Timeline with multiple completed ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), ":"]
    }), "\n", _jsx(TimelineMultipleCompletedData, {}), "\n", _jsxs(_components.h3, {
      children: ["Timeline with multiple current ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), ":"]
    }), "\n", _jsx(TimelineMultipleCurrentData, {}), "\n", _jsxs(_components.h3, {
      children: ["Timeline with multiple upcoming ", _jsx(_components.a, {
        href: "/uilib/components/timeline/properties#timelineitem-properties",
        children: "timeline items"
      }), ":"]
    }), "\n", _jsx(TimelineMultipleUpcomingData, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
